import React, { useState } from 'react';
import styled from 'styled-components';
import { useCollapse } from 'react-collapsed';
import { SvgIcon } from '../Icon';
import { theme } from '../../styles/theme';

interface AccordionProps {
  title: React.ReactNode;
  children: React.ReactNode;
  isDefaultExpanded?: boolean;
  onToggle?: () => void;
}

const AccordionWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  &:not(:last-child) {
    border-bottom: 1px solid ${theme.colors.border};
  }
`;

const AccordionTitle = styled.div`
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  display: flex;
  justify-content: space-between;
  align-items: center;
  column-gap: 4px;
  user-select: none;
  cursor: pointer;
  padding: 8px 12px;
`;

const AccordionContent = styled.div`
  display: flex;
  flex-direction: column;
  padding: 8px 0;
`;

const AccordionTitleWrapper = styled.div`
  display: flex;
  align-items: center;
  column-gap: 4px;
`;

const Accordion = ({
  title,
  children,
  onToggle,
  isDefaultExpanded = false,
}: AccordionProps) => {
  const [isExpanded, setIsExpanded] = useState(isDefaultExpanded);
  const { getCollapseProps, getToggleProps } = useCollapse({ isExpanded });

  const onToggleHandler = () => {
    setIsExpanded(!isExpanded);
    onToggle?.();
  };

  return (
    <AccordionWrapper>
      <AccordionTitle {...getToggleProps({ onClick: onToggleHandler })}>
        <AccordionTitleWrapper>{title}</AccordionTitleWrapper>
        <SvgIcon
          name={isExpanded ? 'caret-down' : 'caret-right'}
          height={16}
          width={16}
          customFill="currentColor"
        />
      </AccordionTitle>
      <div {...getCollapseProps()}>
        <AccordionContent>{children}</AccordionContent>
      </div>
    </AccordionWrapper>
  );
};

export default Accordion;
